import { ComponentType, SVGProps } from 'react';

import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

export const ErrorsFoundLabel = ({
  message,
  icon: Icon,
  className,
}: {
  message: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  className?: string;
}) => (
  <div className={cn('flex items-center', className)}>
    <Icon className="mr-1 size-4 fill-current" />
    <span className={typographyVariants({ variant: 'bodyShort01' })}>
      {message}
    </span>
  </div>
);
